/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function BookIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "book", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.5 5.5L12.5 6.5L20.5 5.5V17.5L12.5 18.5L4.5 17.5V5.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 18.5L12.5 6.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M4.5 17.5V19.5L12.5 18.5L20.5 19.5V17.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M4.5 18.5H20.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(BookIcon);
export default ForwardRef;
//# sourceMappingURL=bookIcon.js.map